import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { API } from "../global";
import { formValidationSchema } from "./AddMovie";

// HOC - Higher order components - Parent (Data) - child (Display)

//PUT = GET + POST
// /movies/add - AddMovie
export function EditMovie() {
  const { id } = useParams();
  // const movie = movies[id];
  // console.log(movies, movie);

  const [movie, setMovie] = useState(null);
  useEffect(() => {
    fetch(`${API}/movies/${id}`, {
      method: "GET",
    }) // returns a promise object
      .then((data) => data.json())
      .then((mv) => setMovie(mv));
  }, []);

  // console.log(movie, movie.poster, movie.summary);

  // Until the movie data is available do not set the form
  return movie ? <UpdateMovie movie={movie} /> : "";
}

function UpdateMovie({ movie }) {
  const history = useHistory();
  const { handleSubmit, values, handleChange, handleBlur, errors, touched } =
    useFormik({
      initialValues: {
        name: movie.name,
        poster: movie.poster,
        summary: movie.summary,
        rating: movie.rating,
        trailer: movie.trailer,
      },
      //   validate: formValidation,
      validationSchema: formValidationSchema,
      onSubmit: (updatedMovie) => {
        console.log("onSubmit", updatedMovie);
        editMovie(updatedMovie);
      },
    });

  const editMovie = (updatedMovie) => {
    // 1. method - PUT & pass the id
    // 2. body - data & JSON
    // 3. headers - JSON data

    fetch(`${API}/movies/${movie.id}`, {
      method: "PUT",
      body: JSON.stringify(updatedMovie),
      headers: { "Content-type": "application/json" },
    }) // returns a promise object
      .then(() => history.push("/movies"));
  };

  return (
    <form onSubmit={handleSubmit} className="add-movie-form">
      <TextField
        id="name"
        name="name"
        value={values.name}
        onChange={handleChange}
        onBlur={handleBlur}
        label="Movie name"
        variant="outlined"
        error={errors.name && touched.name}
        helperText={errors.name && touched.name ? errors.name : ""}
      />

      <TextField
        id="poster"
        name="poster"
        value={values.poster}
        onChange={handleChange}
        onBlur={handleBlur}
        label="Poster url"
        variant="outlined"
        error={errors.poster && touched.poster}
        helperText={errors.poster && touched.poster ? errors.poster : ""}
      />

      <TextField
        id="summary"
        name="summary"
        value={values.summary}
        onChange={handleChange}
        onBlur={handleBlur}
        label="Movie summary"
        variant="outlined"
        error={errors.summary && touched.summary}
        helperText={errors.summary && touched.summary ? errors.summary : ""}
      />
      <TextField
        id="rating"
        name="rating"
        value={values.rating}
        onChange={handleChange}
        onBlur={handleBlur}
        label="Movie rating"
        variant="outlined"
        error={errors.rating && touched.rating}
        helperText={errors.rating && touched.rating ? errors.rating : ""}
      />
      <TextField
        id="trailer"
        name="trailer"
        value={values.trailer}
        onChange={handleChange}
        onBlur={handleBlur}
        label="Movie trailer"
        variant="outlined"
        error={errors.trailer && touched.trailer}
        helperText={errors.trailer && touched.trailer ? errors.trailer : ""}
      />
      <Button color="success" variant="contained" type="submit">
        Save
      </Button>
    </form>
  );
}
